// extracted by mini-css-extract-plugin
export default {"container":"general_container__dR4RU","col":"general_col__uXlWJ"};